import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getORDERSTableStructure";
export const UPDATE_TABLE_DATA = "getORDERSTableData";
export const EXPORT_TABLE_DATA = "exportORDERSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setORDERSTableStructure";
export const SET_TABLE_DATA = "setORDERSTableData";
export const SET_TABLE_FILTER = "setORDERSTableFilter";
// export const SET_FILTER_CHANGE = "setORDERSFilterChange";
export const SET_TABLE_PAGE = "setORDERSTablePage";
export const SET_TABLE_PERPAGE = "setORDERSTablePerPage";
export const SET_TABLE_SORTBY = "setORDERSTableSortBy";
export const SET_TABLE_SORTORDER = "setORDERSTableSortOrder";
export const SET_EXPORT_LINK = "setORDERSExportLink";
export const SET_DEFAULT_EXPORT_TEMPLATE = "setORDERSDefaultExportTemplate";
export const SET_BOXES_DIMENSIONS_ADDED = "setORDERSBoxesDimensionAdded";

const state = {
  queryObject: {},
  defaultExportTemplate: false,
  isBoxesDimensionAdded: true,
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, description
   * */
  getORDERSTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getORDERSWarehouses(state) {
    return state.table_structure.warehouses;
  },
  getORDERSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getORDERSPrintTypes(state) {
    return state.table_structure.print_labels;
  },
  getORDERSExampleFiles(state) {
    return state.table_structure.files;
  },
  getORDERSTableState(state) {
    return state.table_state;
  },
  getORDERSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getORDERSTableFilters(state) {
    return state.table_structure.filters;
  },

  getORDERSTableData(state) {
    return state.table_data.data;
  },
  getORDERSExportUrl(state) {
    return state.export_link;
  },
  getORDERSCallStatuses(state) {
    // console.log(state, state.table_structure.call_statuses[0]);
    return state.table_structure.call_statuses[0];
  },
  getORDERSUploadType(state) {
    return state.table_structure.type;
  },
  getORDERSExtraData(state) {
    return state.table_structure.reason_data;
  },
  getORDERSOrderTypes(state) {
    return state.table_structure.orderTypes;
  },
  getORDERSShippingTypes(state) {
    return state.table_structure.shippingTypes;
  },
  getORDERSDefaultExportTemplate(state) {
    return state.defaultExportTemplate;
  },
  getORDERSBoxesDimensionAdded(state) {
    return state.isBoxesDimensionAdded;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    context.commit(SET_PAGE_LOADING, true);

    return new Promise((resolve) => {
      ApiService.post("/fulfillment/orders")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);

    return new Promise((resolve) => {
      ApiService.post("/fulfillment/orders/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve, reject) => {
      ApiService.post("/fulfillment/orders/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch(() => {
          context.commit(SET_PAGE_LOADING, false);
          reject();
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    // console.log("order state of filter update", filter);
    state.table_state.filters = filter;
  },

  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
  [SET_DEFAULT_EXPORT_TEMPLATE](state, link) {
    state.defaultExportTemplate = link;
  },
  [SET_BOXES_DIMENSIONS_ADDED](state, isBoxesDimensionAdded) {
    state.isBoxesDimensionAdded = isBoxesDimensionAdded;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
